import { shiftEditorViewState } from "..";
import { mutatorAction } from "satcheljs";

export default mutatorAction("updateThemeTimeoff", function updateThemeTimeoff(theme: string) {
    if (shiftEditorViewState().timeoff) {
        shiftEditorViewState().timeoff.theme = theme;
    }
});